import { render } from "./success-notify.vue?vue&type=template&id=0810b781"
import script from "./success-notify.vue?vue&type=script&lang=js"
export * from "./success-notify.vue?vue&type=script&lang=js"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__